export default __webpack_public_path__ + "static/pilot-Andy-304ebff2dc319bb96367f1e262cbd3cb.png";